import $store from '@/store'
import pusherManager from './pusherManager'
const OT = require('@opentok/client')

export default {

  publisher: null,
  republishAttempted: false,

  initSession (token) {
    // if (session && session.currentState !== 'connected') {
    var self = this
    window.opentokSession = self._getSession()
    if (!OT.checkSystemRequirements()) {
      console.log('opentok: Your Browser does not support WebRTC')
    } else {
      console.log('opentok: Init Session')
      OT.setLogLevel(OT.NONE)
      OT.on('exception',
        function (event) {
          console.log('opentok: OT Ex', event)
          // TODO MANAGE EXCEPTION OF HARDWARE OCCUPIED, show message
          if (event.component && (typeof event.component.publish === 'function')) {
            event.component.destroy()
            if (!this.republishAttempted) {
              this.republishAttempted = true
              this._initPublisher(true)
            }
          }
        },
        this
      )
      if (window.opentokSession) {
        if (window.opentokSession && window.opentokSession.currentState === 'disconnected') {
          window.opentokSession.on({
            streamCreated: (event) => {
              self._streamIncoming(event)
            },
            streamDestroyed: (event) => {
              self._streamEnded(event)
            },
            connectionCreated: (event) => {
              self._sessionConnected(event)
            },
            sessionDisconnected: (event) => {
              console.log('opentok: I Disconnected')
              self._sessionDisconnected(event)
            },
            connectionDestroyed: (event) => {
              console.log('opentok: The Customer Disconnected')
              self._sessionDisconnected(event)
            }
          }).connect(token)
        }
      }
    }
    // }
  },

  _getSession () {
    var currentCustomerSessionId = $store.getters.user_get_session_id
    if (currentCustomerSessionId) {
      var apiKey = JSON.parse(JSON.stringify($store.getters.auth_talk_key))
      return OT.initSession(apiKey, currentCustomerSessionId)
    }
    return null
  },

  _streamIncoming (event) {
    console.log('opentok: Stream Incoming ', event)
    window.opentokSession.subscribe(event.stream, 'publisherContainer', {
      insertMode: 'append',
      fitMode: 'contain',
      width: '100%',
      height: '100%'
    }, (error) => {
      if (error) {
        console.log(`opentok: There was an issue subscribing to the stream: ${error}`)
      } else {
        // $store.commit('USER_STREAM', event.stream.id) //
      }
    })
  },

  _streamEnded (event) {
    console.log('opentok: Stream Ended ', event)
    var accountInfo = $store.getters.auth_get_account
    if (event.stream.name === accountInfo.uid) {
    }
  },

  _releaseMedia () {
    try {
      if (window.openTokStream) {
        var tracks = window.openTokStream.getTracks()
        for (var t in tracks) {
          tracks[t].stop()
        }
      }
    } catch (ex) {
      console.log('failed to release media: ', ex)
    }
  },

  _sessionConnected (event) {
    if (window.opentokSession.connection && window.opentokSession.connection.id !== event.connection.id) {
      console.log('opentok: Vendor connected')
    } else {
      console.log('opentok: I Connected')
      // var currentCustomerSessionId = $store.getters.customer_get_session_id
      // $store.commit('SET_OPENTOKCONNECTION', {sessionId: currentCustomerSessionId, connectionId: event.connection.connectionId})
      this._initPublisher()
    }
  },

  _sessionDisconnected (event) {
    this.closeSession()
    // $store.commit('SET_OPENTOKDISCONNECTION') //
  },

  _initPublisher () {
    var self = this
    var publisher = this.publisher
    if (publisher) {
      self._unpublish()
    }

    if (!publisher) {
      self._getPublishOptions().then(
        publisherOptions => {
          console.log('opentok: publisher options ', publisherOptions)
          try {
            publisher = OT.initPublisher('subscriberContainer', publisherOptions, (error) => {
              if (error) {
                return console.log(`opentok: There was an error initializing the publisher: ${error}`)
              }
              self._publishStream(publisher)
            })
          } catch (ex) {
            console.log(ex)
          }
        }
      )
    }
  },

  _publishStream (publisher) {
    var self = this
    if (self.publisher === null) {
      console.log('opentok: publishing...')
      self.publisher = publisher
      try {
        window.opentokSession.publish(publisher, (error) => {
          if (error) {
            return console.log(`opentok: There was an error when trying to publish: ${error}`)
          }
        }).on(
          {
            streamCreated: (event) => {
              console.log('opentok: my stream created', event)
            },
            streamDestoyed: (event) => {
              console.log('opentok: my stream destroyed', event)
            }
          }
        )
      } catch (ex) {
        console.log('opentok: publisher exception', ex)
        // manage camera unavailable
      }
    }
  },

  _unpublish () {
    if (this.publisher) {
      console.log('opentok: unpublishing...')
      window.opentokSession.unpublish(this.publisher)
      this.publisher = null
    }
  },

  _unsetPublisher () {
    if (this.publisher) {
      console.log('opentok: unsetting publisher')
      this.publisher.publishVideo(false)
      this.publisher = null
    }
  },

  _getCurrentPublisher () {
    // CANNOT STORE STREAM, VUEX DOES NOT ALLOW THINGS THAT GET MODIFIED OUTSIDE, WOULD BE GREAT IF OPENTOK MAKES getStreamById
    return this.publisher
  },

  _setVideo (hasVideo) {
    try {
      var publisher = this._getCurrentPublisher()
      if (publisher) {
        publisher.publishVideo(hasVideo)
      } else {
        this._initPublisher()
      }
    } catch (ex) {
      console.log(ex)
    }
  },

  _setAudio (hasAudio) {
    try {
      var publisher = this._getCurrentPublisher()
      if (publisher) {
        publisher.publishAudio(hasAudio)
      } else {
        this._initPublisher()
      }
    } catch (ex) {
      console.log(ex)
    }
  },

  _getPublishOptions () {
    var self = this
    return new Promise((resolve) => {
      var accountInfo = $store.getters.auth_get_account
      var withVideo = $store.getters.user_get_shareVideo
      var withAudio = $store.getters.user_get_shareAudio
      var publisherOptions = {
        insertMode: 'append',
        fitMode: 'contain',
        width: '100%',
        height: '100%',
        name: accountInfo.first_name + ' ' + accountInfo.last_name
      }
      self._requestUserMedia().then(
        response => {
          console.log('opentok: requestMediaResponse', response)
          publisherOptions.publishAudio = response.audio && withAudio
          publisherOptions.publishVideo = response.video && withVideo
          resolve(publisherOptions)
        },
        error => {
          console.log('opentok: requestMediaError', error)
          console.log(error)
          publisherOptions.publishVideo = false
          publisherOptions.publishAudio = false
          resolve(publisherOptions)
        }
      )
    })
  },

  closeSession () {
    console.log('opentok: closing session...')
    try {
      this._releaseMedia()
      this._unsetPublisher()
      if (window.opentokSession && window.opentokSession.currentState !== 'disconnected') {
        console.log('opentok: calling disconnect')
        window.opentokSession.disconnect()
      } else {
         //  $store.commit('SET_OPENTOKCONNECTION', false)
      }
    } catch (ex) {
      console.log('opentok: close session exception: ', ex)
    }
    pusherManager.leaveSaleChannel()
  },

  _getUserMedia () {
    return navigator.getUserMedia ||
          navigator.webkitGetUserMedia ||
          navigator.mozGetUserMedia ||
          navigator.msGetUserMedia
  },

  _requestUserMedia () {
    var self = this
    return new Promise((resolve, reject) => {
      var audio = $store.getters.user_get_shareAudio
      var video = $store.getters.user_get_shareVideo

      var constraints = {
        audio: audio,
        video: video
      }

      navigator.mediaDevices.getUserMedia(constraints).then(
        stream => {
          window.openTokStream = stream
          var audioAvailable = self._getStreamTrackAvailability(stream.getAudioTracks())
          var videoAvailable = self._getStreamTrackAvailability(stream.getVideoTracks())
          resolve({audio: audioAvailable, video: videoAvailable})
        },
        e => {
          switch (e.name) {
            case 'NotFoundError':
            case 'DevicesNotFoundError':
            case 'SourceUnavailableError':
            case 'PermissionDeniedError':
            case 'SecurityError':
            default: reject(new Error(e.name))
          }
        })
    })
  },

  _getStreamTrackAvailability (mediaStreamTracks) {
    if (!mediaStreamTracks.length) {
      return false
    }
    var mediaStreamTrack = mediaStreamTracks[0]
    if (typeof mediaStreamTrack !== 'undefined') {
      if (mediaStreamTrack.enabled && mediaStreamTrack.readyState === 'live') {
        return true
      }
    }
    return false
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/talkManager.js